import FreshVueAudits from '@freshsolutions/fresh-vue-audits'
import FreshVueCards from '@freshsolutions/fresh-vue-cards'
import FreshVueFiles from '@freshsolutions/fresh-vue-files'

// icons
export { default as VuetifyIcons } from './icons.js'

// components
export { default as NoteSaveDialog } from './components/NoteSaveDialog.vue'
export { default as NotesDialog } from './components/NotesDialog.vue'
export { default as NoteSeverityIcon } from './components/NoteSeverityIcon.vue'
export { default as NoteSeveritySelect } from './components/NoteSeveritySelect.vue'

function installI18n(instance) {
  if (instance) {
    // eslint-disable-next-line no-case-declarations
    const locales = require.context(
      './locale',
      true,
      /[A-Za-z0-9-_,\s]+\.json$/i
    )
    locales.keys().forEach((key) => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        const origMessages = instance.getLocaleMessage(locale)

        // we will merge the locale messages with our default messages. After that we will merge the messages from the user back, so they will override our default messages.
        instance.mergeLocaleMessage(locale, locales(key))
        instance.mergeLocaleMessage(locale, origMessages)
      }
    })
  }
}

export default {
  install(Vue, options) {
    const o = options || {}
    const i18n = o.i18n || null
    const apollo = o.apollo || {}

    installI18n(i18n)

    // install plugins
    Vue.use(FreshVueAudits, { i18n })
    Vue.use(FreshVueCards, { i18n })
    Vue.use(FreshVueFiles, { i18n, apollo })
  }
}
